import React from 'react';
import PropTypes from 'prop-types';
import {LoadingCircle} from 'src/shared/components/LoadingCircle';
import {loading, text} from './styles.module.scss';

const loadingHeader = 'Hang Tight!';
const loadingText = `We're gathering your account info and scanning your connection.`;

export const LoadingView = ({
  hideText,
}) => {
  return (
    <>
      <div className={loading}>
        <LoadingCircle />
      </div>
      <div className={text}>
        <h1>{hideText ? '' : `${loadingHeader}`}</h1>
        <p>{hideText ? '' : `${loadingText}`}</p>
      </div>
    </>
  );
};

LoadingView.propTypes = {
  hideText: PropTypes.bool,
};
